/**
 * Amersports-v2環境用の店舗の詳細ページ
 */
import { defineComponent } from 'vue'
import PointPage from "@/organizations/_default/point"

export default defineComponent({
  extends: PointPage,
  setup(props, context) {
    const page = PointPage.setup(props, context)
    const point = storelocator.point.point

    /**
     * GoogleMapsへのリンクURLを生成
     * 直営店の場合は店舗名で検索、それ以外はデフォルト設定に従う
     */
    const googlemapsLink = (name, lat, lng) => {
      if (!storelocator.point.google_map_opener?.enabled) {
        return '';
      }

      const _name = name || point.name;
      const _lat = lat || point.latitude;
      const _lng = lng || point.longitude;

      // 直営店の場合は設定に関わらず店舗名をクエリに使用
      // それ以外はデフォルト設定（google_map_opener.by）に従う
      const isDirect = point.extra_fields["店舗種別"] === "直営店";
      const searchMode = storelocator.point.google_map_opener?.by;
      const useNameQuery = isDirect || searchMode === 'name';
      const query = useNameQuery
        ? `query=${encodeURIComponent(_name)}`
        : `query=${_lat}%2C${_lng}`;

      return `https://www.google.com/maps/search/?api=1&${query}`;
    };

    return {
      ...page,
      googlemapsLink,
    };
  }
});
